import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

function resource() {
  return getClusterId()
    .then(clusterId => `/api/v2/${clusterId}/nfs/auth/krb-settings`);
}

const getInitialState = () => ({
  config: {
    realm: '',
    kdc_service: '',
    kdc_admin_service: ''
  }
});

export default {
  name: 'kerberos',
  namespaced: true,
  state: getInitialState(),
  getters: {
    config: state => state.config,
    isConfigured: state => !!state.config?.realm
  },
  mutations: {
    SET_CONFIG(state, config) {
      state.config = config;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_CONFIG({ commit, dispatch }) {
      return resource({ dispatch }).then(url => this.$api.get(url)).then(({ data }) => {
        commit('SET_CONFIG', data);
      });
    },
    UPDATE({ commit, dispatch }, payload) {
      return resource({ dispatch }).then(url => this.$api.post(url, payload)).then(({ data }) => {
        commit('SET_CONFIG', data);
      });
    }
  }
};
